

@if (visible) {
    <div class="demo-settings-backdrop d-print-none" (click)="visible = false"></div>
}

<p-drawer [(visible)]="visible" header="Muokkaa demon asetuksia" position="right" styleClass="d-print-none" [modal]="false">
    <form [formGroup]="settingControls" style="padding-right: 30px"> 
        <div>
            <label>Saatavuuslista</label>
            <p-select class="w-100" [options]="avTemplates" formControlName="availability|presentationStyle" optionLabel="name" optionValue="value" placeholder="Valitse saatavuuslista" />
        </div>

        <div class="mt-4">
            <label>Kortteja per rivi (vain korttinäkymässä)</label>
            <p-select class="w-100" [options]="cardCounts" formControlName="availability|cardCountPerRow" optionLabel="name" optionValue="value" placeholder="Kortteja per rivi" />
        </div>

        <div class="mt-4">
            <label>Huoneiden järjestys</label>
            <p-select class="w-100" [options]="sortingOptions" formControlName="availability|sorting" optionLabel="name" optionValue="value" placeholder="Huoneiden järjestys" />
        </div>

        <div class="mt-4">
            <p-checkbox formControlName="availability|showPricePerNight" binary="true" inputId="ppn" />
            &nbsp;<label for="ppn">Näytä hinnat per yö</label>
        </div>

        <div class="mt-4">
            <p-checkbox formControlName="multihotel" binary="true" inputId="multihotel" />
            &nbsp;<label for="multihotel">Monen hotellin varausmoottori</label>
        </div>

        <div class="mt-4">
            <p-checkbox formControlName="availability|hideOtherRoomsWhenCodeUsed" binary="true" inputId="hideOtherRoomsWithCode" />
            &nbsp;<label for="hideOtherRoomsWithCode">Näytä vain huoneet, joihin varauskoodi vaikuttaa</label>
            <br>Esimerkkikoodi: <b>Ale20</b>
        </div>

        @if (isInProfile) {
            <div class="mt-4">
                <p-button (click)="fillProfile()">
                    Täytä varaajan tiedot
                </p-button>
            </div>
        }

        <div class="mt-4">
            <a routerLink="/find-reservation">Peruuta varaus</a>
            
        </div>
        
        <div class="mt-4">
            <p-checkbox formControlName="enableDebugMode" binary="true" inputId="enableDebugMode" />
            &nbsp;<label for="enableDebugMode">Debug moodi</label>
        </div>

        <div class="mt-4">
            <p-checkbox formControlName="disablePaymentSuccess" binary="true" inputId="disablePaymentSuccess" />
            &nbsp;<label for="disablePaymentSuccess">Estä maksun onnistuminen (callback testaus)</label>
        </div>

    </form>

    
</p-drawer>



<p-button (click)="visible = true" class="demo-settings-open-drawer-button d-print-none" severity="info">
    <span class="material-symbols-outlined">
        settings
    </span>
</p-button>